import { Alert } from '@mui/material'
import { useUserInfo } from 'src/hooks'

interface EmailConsistencyReminderProps {
    className?: string
}

export const EmailConsistencyReminder = ({
    className
}: EmailConsistencyReminderProps) => {
    const { user } = useUserInfo()

    return (
        <Alert
            severity="warning"
            sx={{ fontWeight: 700, my: 2, p: 0 }}
            className={className}
        >
            Please be sure to use the same email you have registered with Tia,{' '}
            {user?.email}, when checking out to ensure consistency across the
            accounts
        </Alert>
    )
}
